import { render, staticRenderFns } from "./GiteaWorkspaceModal.vue?vue&type=template&id=4e73ab85&"
import script from "./GiteaWorkspaceModal.vue?vue&type=script&lang=js&"
export * from "./GiteaWorkspaceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GiteaWorkspaceModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GiteaWorkspaceModal.vue
// module id = 2355
// module chunks = 1